import React, { useState } from "react";

const EyeIconLot = ({ lot }) => {
  const [haveImages] = useState(lot.images.length > 0);
  const [programHaveAddress] = useState(lot.programme_parent.address);
  const [havePrice] = useState(lot.price_total);
  const [haveSurface] = useState(lot.surface);
  const [showMissing, setShowMissing] = useState(false);
  const handleShowMissing = (e) => {
    e.stopPropagation();
    setShowMissing(true);
  };
  const handleHideMissing = (e) => {
    e.stopPropagation();
    setShowMissing(false);
  };

  return (
    <div
      className="position-relative border"
      style={{ borderRadius: "50%", backgroundColor: "#fff" }}
    >
      <svg
        onMouseEnter={(e) => handleShowMissing(e)}
        onMouseLeave={(e) => handleHideMissing(e)}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        {!haveImages || !programHaveAddress || !havePrice || !haveSurface ? (
          <path
            d="M19.5099 5.85L13.5699 2.42C12.5999 1.86 11.3999 1.86 10.4199 2.42L4.48992 5.85C3.51992 6.41 2.91992 7.45 2.91992 8.58V15.42C2.91992 16.54 3.51992 17.58 4.48992 18.15L10.4299 21.58C11.3999 22.14 12.5999 22.14 13.5799 21.58L19.5199 18.15C20.4899 17.59 21.0899 16.55 21.0899 15.42V8.58C21.0799 7.45 20.4799 6.42 19.5099 5.85ZM11.2499 7.75C11.2499 7.34 11.5899 7 11.9999 7C12.4099 7 12.7499 7.34 12.7499 7.75V13C12.7499 13.41 12.4099 13.75 11.9999 13.75C11.5899 13.75 11.2499 13.41 11.2499 13V7.75ZM12.9199 16.63C12.8699 16.75 12.7999 16.86 12.7099 16.96C12.5199 17.15 12.2699 17.25 11.9999 17.25C11.8699 17.25 11.7399 17.22 11.6199 17.17C11.4899 17.12 11.3899 17.05 11.2899 16.96C11.1999 16.86 11.1299 16.75 11.0699 16.63C11.0199 16.51 10.9999 16.38 10.9999 16.25C10.9999 15.99 11.0999 15.73 11.2899 15.54C11.3899 15.45 11.4899 15.38 11.6199 15.33C11.9899 15.17 12.4299 15.26 12.7099 15.54C12.7999 15.64 12.8699 15.74 12.9199 15.87C12.9699 15.99 12.9999 16.12 12.9999 16.25C12.9999 16.38 12.9699 16.51 12.9199 16.63Z"
            fill="#ff3379"
          />
        ) : (
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
            fill="#95ce00"
          />
        )}
      </svg>{" "}
      {showMissing && (
        <div
          className="position-absolute text-start f12"
          style={{
            fontSize: "12px",
            width: "max-content",
            top: "100%",
            right: "0",
            zIndex: 10000,
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        >
          {!haveImages || !programHaveAddress || !havePrice || !haveSurface ? (
            <div>Ce bien et masqué du site à cause des manques suivants:</div>
          ) : (
            <div>Ce bien est visible sur le site</div>
          )}

          <div>
            {!haveImages && <div>- Images</div>}
            {!programHaveAddress && <div>- Adresse</div>}
            {!havePrice && <div>- Prix</div>}
            {!haveSurface && <div>- Surface</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default EyeIconLot;
